// // console.log("Script loaded and DOM is ready");

var activeVariant = null;
// Parse the variant metadata object
const variantMetadata = JSON.parse(
  document.getElementById("variant-metafields-data").textContent
);
const variantSelector = document.querySelector(".variant-selection__variants");
if (!variantSelector) {
  // console.error("Variant selector not found");
}
const galleryViewer = document.querySelector(".product-gallery--viewer");

const observer = new MutationObserver(() => {
  const variantSelector = document.querySelector(".variant-selection");
  if (variantSelector) {
    observer.disconnect(); // Stop observing once the element is found
    setupVariantChangeHandler(variantSelector);
  }
});

observer.observe(document.body, { childList: true, subtree: true });
// Function to Calculate Total Price
function calculateTotalPrice() {
  // Helper to parse price strings
  function parsePrice(priceString) {
    if (!priceString) return 0; // Default to 0 if price is missing or invalid
    // ensure is string
    priceString = priceString.toString();
    return parseFloat(priceString.replace(/[^0-9.-]+/g, "")); // Remove $ and commas
  }

  // Gather base price
  const basePriceElement = document.querySelector("[data-price]");
  const basePrice = basePriceElement
    ? parsePrice(basePriceElement.innerText)
    : 0;

  let totalPrice = basePrice;
  // console.log("Base Price:", basePrice);

  // Add Finish Prices
  const selectedFinish = document.querySelector(
    "#base-finishes .selected span[data-price]"
  );
  if (selectedFinish) {
    const finishPrice = parsePrice(selectedFinish.dataset.price || "0");
    // console.log("Base Finish Price:", finishPrice);
    totalPrice += finishPrice;
  }

  const selectedCountertopFinish = document.querySelector(
    "#countertop-finishes .selected span[data-price]"
  );
  if (selectedCountertopFinish) {
    const finishPrice = parsePrice(
      selectedCountertopFinish.dataset.price || "0"
    );
    totalPrice += finishPrice;
    // console.log("countertop Finish Price:", finishPrice);
  }

  const selectedComponentFinish = document.querySelector(
    "#component-finishes .selected span[data-price]"
  );
  if (selectedComponentFinish) {
    const finishPrice = parsePrice(
      selectedComponentFinish.dataset.price || "0"
    );
    totalPrice += finishPrice;
    // console.log("component Finish Price:", finishPrice);
  }

  // Add Storage Prices
  [
    "section-a-storage-options",
    "section-b-storage-options",
    "section-c-storage-options",
    "grill-section-storage-options",
  ].forEach((id) => {
    const selectedOption = document.querySelector(
      `input[name="${id}"]:checked`
    );
    // console.log("Selected Option:", selectedOption);
    if (selectedOption) {
      const priceElement =
        selectedOption.parentElement.querySelector("span[data-price]");
      const optionPrice = parsePrice(priceElement?.dataset.price / 100 || "0");
      totalPrice += optionPrice;
      // console.log("Storage Price:", optionPrice);
    }
  });

  const selectedExtrasInputs = document.querySelectorAll(
    'input[name="extras"]:checked'
  );
  selectedExtrasInputs.forEach((selectedExtra) => {
    const priceElement =
      selectedExtra.parentElement.querySelector("span[data-price]");
    const optionPrice = parsePrice(priceElement?.dataset.price || "0");
    totalPrice += optionPrice;
    // console.log("Extras Price:", optionPrice);
  });
  // Add Grill Price
  const selectedGrill = document.querySelector(
    'input[name="grill-options"]:checked'
  );
  if (selectedGrill) {
    // Get the Fuel Type
    const fuelType = document.querySelector('input[name="fuel-type"]:checked');
    var grillTitle = "";
    var grill = null;
    // get the grill title from the active variant's grill metadata

    activeVariantMetadata.grill.forEach((g) => {
      if (g.id == selectedGrill.value) {
        console.log("Grill Title:", g.title);

        // remove last item from title
        if (g.title.includes("/"))
          grillTitle = g.title.split("/").slice(0, -1).join("/");
        else grillTitle = g.title;
        grill = g;
        console.log("Grill Title:", grillTitle);
      }
    });

    const fuelTypeText = fuelType ? fuelType.value : "Propane";
    // find the grill that matches the selection and fuel type
    // look for the fuel type in the grill title. look for the grill items in the active variant, title should include selectedGrill title and fuel type title
    // only if grillTitle is not No Grill

    if (grillTitle != "No Grill")
      grill = activeVariantMetadata.grill.find(
        (g) => g.title.includes(grillTitle) && g.title.includes(fuelTypeText)
      );
    console.log("Selected Grill:", grill);

    // get the price of the grill
    const grillPrice = parsePrice(grill.price / 100 || "0");

    totalPrice += grillPrice;
    console.log("Grill Price:", grillPrice);
  }
  // Update base price display
  const basePriceDisplay = document.querySelector(".price__current");

  if (basePriceDisplay) {
    // Remove existing total price span if it exists
    const existingTotalPrice = basePriceDisplay.querySelector(".total-price");
    if (existingTotalPrice) {
      existingTotalPrice.remove();
    }
    // Append new total price span
    basePriceDisplay.insertAdjacentHTML(
      "beforeend",
      ` <span class="total-price">$${totalPrice.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}</span>`
    );
  }

  // Update the total price display
  const totalPriceDisplay = document.getElementById("total-price-display");
  if (totalPriceDisplay) {
    totalPriceDisplay.textContent = `$${totalPrice.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  // console.log("Total Price:", totalPrice);

  return totalPrice.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }); // Return total for further use if needed
}
function setupVariantChangeHandler(variantSelector) {
  // console.log("Variant selector found, setting up event listener");
  variantSelector.addEventListener("change", function () {
    // selected variant ID is in the variant attribute
    const selectedVariantId = this.attributes["variant"].value;

    // set the variant param in the url
    const url = new URL(window.location.href);
    url.searchParams.set("variant", selectedVariantId);
    window.history.replaceState({}, "", url.toString());
    // what is the index of the current selected .options-selection__input-select
    selectedVariantIndex = document.querySelector(
      ".options-selection__input-select"
    ).selectedIndex;
    // console.log("Variant selected:", selectedVariantIndex);

    // console.log("Variant selected:", selectedVariantId);
    // populate the product description
    updateDescription(selectedVariantId, selectedVariantIndex);
    updateVariantOptions(selectedVariantId, selectedVariantIndex);
    updateGalleryImage(selectedVariantId, selectedVariantIndex);
  });
}

function updateDescription(variantId, selectedVariantIndex) {
  const descriptionElement = document.querySelector(
    ".product-block--description"
  );

  // console.log(descriptionElement);
  activeVariant = variantMetadata.variants.find(
    (variant) => variant.id.toString() === variantId.toString()
  );
  if (!activeVariant) {
    // console.error("Variant not found.");
    return;
  }
  // console.log(activeVariant.description);
  if (descriptionElement) {
    descriptionElement.innerHTML = activeVariant.description;
  }
}

function updateGalleryImage(variantId, selectedVariantIndex) {
  // Find all figures in the gallery
  const galleryFigures = galleryViewer.querySelectorAll(
    "[data-gallery-figure]"
  );

  // Reset the selected state of all figures
  galleryFigures.forEach((figure) => {
    figure.setAttribute("aria-hidden", "true");
    figure.setAttribute("data-gallery-selected", "false");
  });

  // Find the figure that is the same index as selectedVariantIndex
  const matchingFigure = document.querySelector(
    `figure[data-gallery-index="${selectedVariantIndex}"]`
  );

  if (matchingFigure) {
    matchingFigure.setAttribute("aria-hidden", "false");
    matchingFigure.setAttribute("data-gallery-selected", "true");
  } else {
    // console.warn("No matching gallery image found for variant:", variantId);
  }
}

function updateVariantOptions(variantId) {
  variantId = parseInt(variantId);
  // console.log("Updating variant options for:", variantId);
  // console.log("Variant Metadata:", variantMetadata);
  activeVariant = variantMetadata.variants.find(
    (variant) => variant.id === variantId
  );
  if (!activeVariant) {
    // console.error("Variant not found.");
    return;
  }
  // Set the base price

  // Update the current price
  const priceElement = document.querySelector("[data-price]");
  if (priceElement) {
    priceElement.textContent = `$${(activeVariant.price / 100).toFixed(2)}`; // Convert cents to dollars
    // console.log("Current price updated to:", priceElement.textContent);
  }

  // Update compare-at price if available
  const compareAtPriceElement = document.querySelector("[data-price-compare]");
  if (compareAtPriceElement) {
    if (activeVariant.compare_at_price) {
      compareAtPriceElement.textContent = `$${(
        activeVariant.compare_at_price / 100
      ).toFixed(2)}`; // Convert cents to dollars
      compareAtPriceElement.parentElement.classList.remove("hidden"); // Show the compare-at price
    } else {
      compareAtPriceElement.parentElement.classList.add("hidden"); // Hide if no compare-at price
    }
  }

  populateProductOptions("grill-options", activeVariant.grill);
  populateProductOptions(
    "section-a-storage-options",
    activeVariant.section_a_storage_components
  );
  populateProductOptions(
    "section-b-storage-options",
    activeVariant.section_b_storage_components
  );

  if (activeVariant.section_c_storage_components) {
    // show the div storage-c-container
    document.getElementById("storage-c-container").style.display = "block";
    populateProductOptions(
      "section-c-storage-options",
      activeVariant.section_c_storage_components
    );
  } else {
    document.getElementById("storage-c-container").style.display = "none";
    // Empty the section C storage options container
    const sectionCContainer = document.getElementById(
      "section-c-storage-options"
    );
    if (sectionCContainer) {
      sectionCContainer.innerHTML = "";
    }
  }
  populateProductOptions(
    "grill-section-storage-options",
    activeVariant.grill_section_storage_components
  );
  populateFinishButtons("base-finishes", activeVariant.base_finishes);
  populateFinishButtons(
    "countertop-finishes",
    activeVariant.countertop_finishes
  );
  populateFinishButtons(
    "component-finishes",
    activeVariant.components_finishes
  );

  populateProductOptionsFromList("fuel-type", activeVariant.fuel_type);
  populateProductOptionsFromList(
    "grill-location",
    activeVariant.grill_location
  );
  populateProductOptionsFromList("extras", activeVariant.extras);
  // Update the order summary
  document.getElementById("order-form").dispatchEvent(new Event("change"));
}

function uniqueId() {
  return Math.random().toString(36).substring(2, 9);
}
const refId = uniqueId();

const sectionData = JSON.parse(
  document.getElementById("product-data").textContent
);

updateDescription(sectionData.variant.id, 0);
// Finish colors data from your product JSON
const finishColors = JSON.parse(
  document.getElementById("finish-colors-data").textContent
);

// // console.log("finishColors", finishColors);

activeVariant = sectionData.variant;
// Retrieve the active variant's metadata
const activeVariantMetadata = variantMetadata.variants.find(
  (variant) => variant.id === activeVariant.id
);

if (!activeVariantMetadata) {
  // console.error("Active variant metadata not found!");
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Helper to find the title from metadata
function findTitleById(metadataArray, selectedId) {
  if (!metadataArray || !Array.isArray(metadataArray)) return "Unknown Option";
  const item = metadataArray.find((element) => element?.id === selectedId);
  return item ? item.title : "Unknown Option";
}
// // console.log("variantMetadata", variantMetadata);
// Helper function to populate image radio buttons
function populateFinishButtons(fieldsetId, finishIds) {
  const fieldset = document.getElementById(fieldsetId);
  fieldset.innerHTML = "";

  finishIds.forEach((finishId, index) => {
    const finish = finishColors.find((f) => f.id === finishId);
    if (finish) {
      const label = document.createElement("label");
      label.classList.add("finish-option");

      const input = document.createElement("input");
      input.type = "radio";
      input.name = fieldsetId; // Group by fieldset
      input.value = finish.id; // Automatically select the first option
      if (index === 0) {
        input.checked = true;
        label.classList.add("selected");
      }

      const img = document.createElement("img");
      img.src = finish.image;
      img.alt = finish.color_name;
      img.style.width = "100px";
      img.style.height = "100px";
      img.classList.add("finish-image");

      const upcharge = document.createElement("span");
      upcharge.textContent = finish.upcharge ? " +" + finish.upcharge : "";
      upcharge.dataset.price = finish.upcharge || 0;

      label.appendChild(input);
      label.appendChild(img);
      label.appendChild(document.createElement("br"));
      label.appendChild(document.createTextNode(finish.color_name));
      label.appendChild(document.createElement("br"));
      label.appendChild(upcharge);
      fieldset.appendChild(label);
    }
  });
}
// helper function to populate product options from a single text list for Fuel Type, Grill Location and Extras
function populateProductOptionsFromList(containerId, options) {
  const container = document.getElementById(containerId);
  container.innerHTML = ""; // Clear existing options

  if (!options || options.length === 0) {
    container.innerHTML = "<p>No options available for this category.</p>";
    return;
  }
  // display as checkboxes
  options.forEach((option, index) => {
    const label = document.createElement("label");
    label.classList.add("product-option");

    const input = document.createElement("input");
    const priceContainer = document.createElement("span");
    if (containerId === "extras") {
      input.type = "checkbox";
      // split the price out of the option if it exists
      // examples: Electrical - $500 (up to 50')
      // price is $500
      // example: Natural Gas - Bid Only
      // price is $0
      // example: run up to 50' of electrical +$500
      // price is $500
      let price = 0;
      const priceMatch = option.match(/\$(\d+)/);
      if (priceMatch) {
        price = parseInt(priceMatch[1]);
      } else {
        price = 0;
      }
      input.setAttribute("data-price", price);
      // Add price display
      priceContainer.textContent = `$${price}`;
      if (price < 0) {
        priceContainer.classList.add("negative");
        price = Math.abs(price);
      } else if (price == 0) {
        priceContainer.classList.add("zero");
      }
      priceContainer.style.display = "block";
      priceContainer.setAttribute("data-price", price); // Store the price in the element
    } else {
      input.type = "radio";
    }
    input.name = containerId; // Group by container ID
    input.value = option;

    // Automatically select the first option
    if (index === 0 && containerId !== "extras") {
      input.checked = true;
      label.classList.add("selected");
    }

    const title = document.createElement("span");
    title.textContent = option;

    label.appendChild(input);
    label.appendChild(title);

    label.appendChild(priceContainer); // Add price to the label

    container.appendChild(label);
  });
}

function decodeHtmlEntities(text) {
  const txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value;
}
function populateProductOptions(containerId, options) {
  const container = document.getElementById(containerId);
  container.innerHTML = ""; // Clear existing options

  if (!options || options.length === 0 || options[0] === null) {
    container.innerHTML = "<p>No options available for this category.</p>";
    return;
  }

  // Set to track unique first elements
  const uniqueFirstElements = new Set();

  var basePrice = 0;
  options.forEach((option, index) => {
    const fullTitle = decodeHtmlEntities(option.title);
    let firstElement = fullTitle.split("/")[0].trim(); // Get the first part before `/`

    if (firstElement == "Built-In") {
      firstElement = fullTitle.split("/")[1].trim();
    }

    // Skip if this first element is already processed
    if (uniqueFirstElements.has(firstElement)) return;
    uniqueFirstElements.add(firstElement);

    const label = document.createElement("label");
    label.classList.add("product-option");

    const input = document.createElement("input");
    input.type = "radio";
    input.name = containerId; // Group by container ID
    input.value = option.id;
    // Automatically select the first option
    if (index === 0) {
      input.checked = true;
      label.classList.add("selected");
      // the base price is the first option. Set a variable
      basePrice = option.price;
    }

    const img = document.createElement("img");
    img.src = option.image;
    img.alt = firstElement;

    const title = document.createElement("span");
    title.textContent = firstElement;

    // Add price display
    const price = document.createElement("span");
    // subtract the base price from the option price
    var upcharge = option.price - basePrice;
    if (upcharge < 0) {
      price.classList.add("negative");
      upcharge = Math.abs(upcharge);
    } else if (upcharge == 0) {
      price.classList.add("zero");
    }
    price.textContent = `$${(upcharge / 100).toFixed(2) || "0"}`; // Convert cents to dollars

    price.style.display = "block";

    price.setAttribute("data-price", option.price); // Store the price in the element

    label.appendChild(input);
    label.appendChild(img);
    label.appendChild(title);

    label.appendChild(price); // Add price to the label

    container.appendChild(label);
  });
}
var currentVariantMetadata = variantMetadata.variants.find(
  (v) => v.id === activeVariant.id
);
function filterGrillByFuelType(grillOptions, selectedGrillValue) {
  let fuelTypeSelected = "Propane";
  const fuelTypeInput = document.querySelector(
    'input[name="fuel-type"]:checked'
  );
  if (fuelTypeInput) {
    fuelTypeSelected = fuelTypeInput.value;
  }

  // Get the base grill title from the selected grill option
  let baseGrillTitle = "";
  const selectedGrill = grillOptions.find((g) => g.id == selectedGrillValue);
  if (selectedGrill) {
    if (selectedGrill.title.includes("/")) {
      baseGrillTitle = selectedGrill.title.split("/").slice(0, -1).join("/");
    } else {
      baseGrillTitle = selectedGrill.title;
    }
  }

  if (baseGrillTitle && baseGrillTitle !== "No Grill") {
    return grillOptions.filter(
      (g) =>
        g.title.includes(baseGrillTitle) && g.title.includes(fuelTypeSelected)
    );
  } else {
    return grillOptions;
  }
}
function filterStorageComponentsByFuelType(components) {
  let fuelTypeSelected = "Propane";
  return components
  // .filter((component) =>
  //   component.title.includes(fuelTypeSelected)
  // );
}
populateProductOptions("grill-options", currentVariantMetadata.grill);
populateProductOptions(
  "section-a-storage-options",
  filterStorageComponentsByFuelType(
    currentVariantMetadata.section_a_storage_components
  )
);
populateProductOptions(
  "section-b-storage-options",
  filterStorageComponentsByFuelType(
    currentVariantMetadata.section_b_storage_components
  )
);
if (currentVariantMetadata.section_c_storage_components) {
  // show the div storage-c-container
  document.getElementById("storage-c-container").style.display = "block";

  populateProductOptions(
    "section-c-storage-options",
    filterStorageComponentsByFuelType(
      currentVariantMetadata.section_c_storage_components
    )
  );
}
populateProductOptions(
  "grill-section-storage-options",
  currentVariantMetadata.grill_section_storage_components
);
// Populate radio button groups
populateFinishButtons("base-finishes", currentVariantMetadata.base_finishes);
populateFinishButtons(
  "countertop-finishes",
  currentVariantMetadata.countertop_finishes
);
populateFinishButtons(
  "component-finishes",
  currentVariantMetadata.components_finishes
);
populateProductOptionsFromList("fuel-type", currentVariantMetadata.fuel_type);
populateProductOptionsFromList(
  "grill-location",
  currentVariantMetadata.grill_location
);
populateProductOptionsFromList("extras", currentVariantMetadata.extras);

// watch for form changes and update the order summary
document.getElementById("order-form").addEventListener("change", function () {
  const selectedGrill = document.querySelector(
    'input[name="grill-options"]:checked'
  );

  const selectedBase = document.querySelector(
    'input[name="base-finishes"]:checked'
  );
  const selectedCountertop = document.querySelector(
    'input[name="countertop-finishes"]:checked'
  );
  const selectedComponent = document.querySelector(
    'input[name="component-finishes"]:checked'
  );
  const selectedStorageA = document.querySelector(
    'input[name="section-a-storage-options"]:checked'
  );
  const selectedStorageB = document.querySelector(
    'input[name="section-b-storage-options"]:checked'
  );
  const selectedStorageC = document.querySelector(
    'input[name="section-c-storage-options"]:checked'
  );
  const selectedGrillStorage = document.querySelector(
    'input[name="grill-section-storage-options"]:checked'
  );
  // ensure product-option gets selected class
  const productOptions = document.querySelectorAll(".product-option");
  productOptions.forEach((option) => {
    if (option.querySelector("input").checked) {
      option.classList.add("selected");
    } else {
      option.classList.remove("selected");
    }
  });
  // ensure finish-option gets selected class
  const finishOptions = document.querySelectorAll(".finish-option");
  finishOptions.forEach((option) => {
    if (option.querySelector("input").checked) {
      option.classList.add("selected");
    } else {
      option.classList.remove("selected");
    }
  });

  let totalPrice = 0;
  totalPrice = calculateTotalPrice();

  // gather all text content from the container's innerText
  function getOptionText(selectedOption) {
    if (!selectedOption) return "Unknown Option";

    // Get the innerHTML of the parent element
    let innerHTML = selectedOption.parentElement.innerHTML;

    // Remove all <input> elements using a regex
    innerHTML = innerHTML.replace(/<input[^>]*>/gi, "");

    // Return the filtered HTML
    return innerHTML.trim(); // Trim extra whitespace
  }

  // Display the order summary
  const orderSummary = document.getElementById("order-summary");
  const sectionCSummary = selectedStorageC
    ? `<p><b>Section C Storage:</b><br> ${getOptionText(selectedStorageC)}</p>`
    : "";
  const selectedExtras = document.querySelectorAll(
    'input[name="extras"]:checked'
  );
  const extrasText =
    selectedExtras.length > 0
      ? `<p><b>Extras:</b><br> ${Array.from(selectedExtras)
          .map((extra) => getOptionText(extra))
          .join("<br>")}</p>`
      : "";
  const grillLocation = document.querySelector(
    'input[name="grill-location"]:checked'
  );

  const fuelType = document.querySelector('input[name="fuel-type"]:checked');
  const fuelTypeText = fuelType
    ? `<strong>Fuel Type:</strong>${getOptionText(fuelType)}`
    : "";
  const grillLocationText = grillLocation
    ? `<strong>Grill Location:</strong>${getOptionText(grillLocation)}`
    : "";
  orderSummary.innerHTML = `
  <h3>Order Summary</h3>
  <div id="finishes-row">
    <b>Base:</b><b>Countertop:</b><b>Component:</b>
    <div>${getOptionText(selectedBase)}</div>
    <div>${getOptionText(selectedCountertop)}</div>
    <div>${getOptionText(selectedComponent)}</div>
  </div> 
  <div id="storage-row">
  <p><b>Grill:</b><br> ${getOptionText(selectedGrill)}
  ${grillLocationText}
  </p>
  <p><b>Section A Storage:</b><br> ${getOptionText(selectedStorageA)}</p>
  <p><b>Section B Storage:</b><br> ${getOptionText(selectedStorageB)}</p>
  ${sectionCSummary}
  <p><b>Grill Section Storage:</b><br> ${getOptionText(
    selectedGrillStorage
  )}</p>
  ${extrasText}
  </div>
    <p id="total-price-display"><b>Total Price:</b> $${totalPrice}</p>
`;
});
// execute once
document.getElementById("order-form").dispatchEvent(new Event("change"));

// Handle form submission
async function fetchWithRetry(url, maxRetries = 30, delay = 3000) {
  let retries = 0;
  let result = null;

  while (retries < maxRetries) {
    try {
      const response = await fetch(url);
      if (response.ok) {
        result = await response.json();
        if (result) {
          return result; // Return the result if it's valid
        }
      }
    } catch (error) {
      console.error(`Attempt ${retries + 1} failed:`, error);
    }

    retries++;
    // console.log(`Retrying... (${retries}/${maxRetries})`);
    await new Promise((resolve) => setTimeout(resolve, delay)); // Wait before retrying
  }

  // console.error("Max retries reached. Unable to retrieve valid cache result.");
  return null; // Return null if all retries are exhausted
}
function findFinishDetails(finishId, finishesArray) {
  if (!finishesArray || !Array.isArray(finishesArray)) return null;
  const finish = finishesArray.find((f) => f.id === finishId);
  if (finish) {
    return {
      title: finish.color_name || "Unknown Finish",
      type: finish.type || "Standard Finish",
      image: finish.image || "",
    };
  }
  return null;
}
document
  .getElementById("order-form")
  .addEventListener("submit", async function (event) {
    event.preventDefault();
    // diasable the submit button
    document.getElementById("submit-order").disabled = true;
    // show the spinner
    document.getElementById("spinner").style.display = "block";

    // Collect Customer Information
    const preparedBy = document.getElementById("prepared_by").value;
    const firstName = document.getElementById("first_name").value;
    const lastName = document.getElementById("last_name").value;
    const address = document.getElementById("address").value;
    const city = document.getElementById("city").value;
    const state = document.getElementById("state").value;
    const zipCode = document.getElementById("zip_code").value;
    const email = document.getElementById("email").value;
    const phone = document.getElementById("phone").value;

    // Validate Customer Information
    if (
      !preparedBy ||
      !firstName ||
      !lastName ||
      !address ||
      !city ||
      !state ||
      !zipCode ||
      !email ||
      !phone
    ) {
      alert("Please fill out all customer information fields.");
      return;
    }

    const selectedBase = document.querySelector(
      'input[name="base-finishes"]:checked'
    );
    const selectedCountertop = document.querySelector(
      'input[name="countertop-finishes"]:checked'
    );
    const selectedComponent = document.querySelector(
      'input[name="component-finishes"]:checked'
    );

    if (!selectedBase || !selectedCountertop || !selectedComponent) {
      alert("Please select finishes for all categories!");
      return;
    }
    // Assuming finishColors contains all the finish data
    const selectedBaseDetails = findFinishDetails(
      selectedBase.value,
      finishColors
    );
    const selectedCountertopDetails = findFinishDetails(
      selectedCountertop.value,
      finishColors
    );
    const selectedComponentDetails = findFinishDetails(
      selectedComponent.value,
      finishColors
    );
    const selectedGrill = document.querySelector(
      'input[name="grill-options"]:checked'
    );
    const selectedStorageA = document.querySelector(
      'input[name="section-a-storage-options"]:checked'
    );
    const selectedStorageB = document.querySelector(
      'input[name="section-b-storage-options"]:checked'
    );
    const selectedGrillStorage = document.querySelector(
      'input[name="grill-section-storage-options"]:checked'
    );

    const grillLocation = document.querySelector(
      'input[name="grill-location"]:checked'
    );
    const extras = document.querySelector('input[name="extras"]:checked');

    const fuelType = document.querySelector('input[name="fuel-type"]:checked');

    if (
      !selectedGrill ||
      !selectedStorageA ||
      !selectedStorageB ||
      !selectedGrillStorage
    ) {
      alert("Please select options for all categories.");
      return;
    }
    function escapeValue(value) {
      if (!value) return "";
      return value
        .replace(/"/g, "&quot;") // Replace double quotes
        .replace(/'/g, "&#39;"); // Replace single quotes
    }

    // Helper function to find a storage component by finish type
    function findStorageComponentByFinishType(storageOptions, finishType) {
      if (!storageOptions || !Array.isArray(storageOptions)) return null;
      return storageOptions.find((option) =>
        option.title.toLowerCase().includes(finishType.toLowerCase())
      );
    }
    // helper function to find a grill by fuel type
    function findGrillByFuelType(grillOptions, fuelType) {
      if (!grillOptions || !Array.isArray(grillOptions)) return null;
      return grillOptions.find((option) =>
        option.title.toLowerCase().includes(fuelType.toLowerCase())
      );
    }

    // get the grill compoenent
    const selectedGrillDetails = findGrillByFuelType(
      activeVariantMetadata.grill,
      fuelType.value
    );

    // Get the selected component finish type
    const selectedComponentFinishType =
      selectedComponentDetails?.type || "Standard Finish";

    // Match storage components dynamically
    const matchedSectionA = findStorageComponentByFinishType(
      activeVariantMetadata.section_a_storage_components,
      selectedComponentFinishType
    );

    const matchedSectionB = findStorageComponentByFinishType(
      activeVariantMetadata.section_c_storage_components,
      selectedComponentFinishType
    );
    const matchedSectionC = findStorageComponentByFinishType(
      activeVariantMetadata.section_b_storage_components,
      selectedComponentFinishType
    );

    const matchedGrillSection = findStorageComponentByFinishType(
      activeVariantMetadata.grill_section_storage_components,
      selectedComponentFinishType
    );

    // console.log("selectedComponentFinishType:", selectedComponentFinishType);
    // console.log("Matched Section A:", matchedSectionA);
    // console.log("Matched Section B:", matchedSectionB);
    // console.log("Matched Section C:", matchedSectionC);
    // console.log("Matched Grill Section:", matchedGrillSection);
    // console.log("Selected Grill Details:", selectedGrillDetails);

    // Create the line items for the draft order
    const lineItems = [
      {
        title: escapeValue(activeVariant.title), // Use the active variant title
        variant_id: "gid://shopify/ProductVariant/" + activeVariant.id,
        quantity: 1,
        customAttributes: [
          {
            key: "Base Finish",
            value: selectedBaseDetails?.title || "Unknown Finish",
          },
          {
            key: "Countertop Finish",
            value: selectedCountertopDetails?.title || "Unknown Finish",
          },
          {
            key: "Component Finish",
            value: selectedComponentDetails?.title || "Unknown Finish",
          },
          {
            key: "Grill Fuel Type",
            value: fuelType.value,
          },
          {
            key: "Grill Location",
            value: grillLocation.value,
          },
          (extras?.value || "").length > 0 && {
            key: "Extras",
            value: extras?.value,
          },
        ],
      },
      ,
      matchedSectionA && {
        title: escapeValue(matchedSectionA.title),
        variant_id: "gid://shopify/ProductVariant/" + matchedSectionA.id,
        quantity: 1,
      },
      matchedSectionB && {
        title: escapeValue(matchedSectionB.title),
        variant_id: "gid://shopify/ProductVariant/" + matchedSectionB.id,
        quantity: 1,
      },
      matchedSectionC && {
        title: escapeValue(matchedSectionC.title),
        variant_id: "gid://shopify/ProductVariant/" + matchedSectionC.id,
        quantity: 1,
      },
      selectedGrillDetails && {
        title: escapeValue(selectedGrillDetails.title),
        variant_id: "gid://shopify/ProductVariant/" + selectedGrillDetails.id,
        quantity: 1,
      },
      matchedGrillSection && {
        title: escapeValue(matchedGrillSection.title),
        variant_id: "gid://shopify/ProductVariant/" + matchedGrillSection.id,
        quantity: 1,
      },
    ].filter(Boolean); // Remove null or undefined entries;

    const payload = {
      email: email, // Customer email
      phone: phone, // Customer phone
      customer: {
        id: document.getElementById("customer-id").value,
        prepared_by: preparedBy,
        first_name: firstName,
        last_name: lastName,
        address: address,
        city: city,
        state: state,
        zip_code: zipCode,
      },
      line_items: lineItems,
      note: "Created via Blue Haven Pools form submission.",
    };
    // console.log("Payload:", payload);
    try {
      const response = await fetch(
        "https://webhooks.mechanic.dev/9cc325b2-9d69-4bd4-b406-84f1a8e99ce2",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        // Introduce a delay before sending the request
        const cacheResult = await fetchWithRetry(
          "https://usemechanic.com/cache/58e21ce2-e584-4e67-94ff-f632f78dbea9"
        );

        // console.log("Cache Result", cacheResult);
        if (cacheResult.draftOrder) {
          // console.log(
          //   `Draft Order Created: ${cacheResult.draftOrder.id}`
          // );
        } else if (cacheResult?.error) {
          console.log(`Error: ${cacheResult.error}`);
          alert("Something went wrong. Please try again.");
        } else {
          alert("Something went wrong. Please try again.");
        }
        // diasable the submit button
        document.getElementById("submit-order").disabled = false;
        // show the spinner
        document.getElementById("spinner").style.display = "none";

        // populate the form-response div and display it

        document.getElementById(
          "form-response"
        ).innerHTML = `<div class="alert alert-success" role="alert">
          <h4 class="alert-heading">Order Submitted Successfully!</h4>
          <p>Your order has been submitted successfully. Our team will reach out to you shortly.</p>
        </div>`;
        // reset the form
        document.getElementById("order-form").reset();
      } else {
        const error = await response.json();
        console.error("Error:", error);
        alert("Failed to create draft order.");
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("An error occurred while creating the draft order.");
    }
  });
